import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Grid, Row, Col, Well } from 'react-bootstrap'
import dayjs from 'dayjs'
import ReactTable from 'react-table'
import ReactJson from 'react-json-view'
import 'react-table/react-table.css'

import PackageIdCheck from '../DeliveryUtils/PackageIdCheck'
import ReRunDeliveryModal from '../DeliveryUtils/ReRunDeliveryModal'
import Hotspotter from './Hotspotter'
import TableFilterDropdown from '../../../common/components/TableFilterDropdown'
import { fetchCollection } from '../../../common/redux/collectionActions'

class DeliverySearch extends Component {
        state = { input: {}, data: [], filter: { carrierId: '' }, showReRunModal: false, reRunModalData: null }


    updateSearch = (e) => {
        var state = { ...this.state }
        state.input[e.target.name] = e.target.value
        this.setState(state)
    }

    search = () => {
        const searchObject = { packageId: this.state.input.packageId, text: this.state.input.textInput, daysback: 7 }

        fetch(`${window.MYQLOCX_API}/subject/admin/bi/deliverysearch`, {
            method: 'POST',
            headers: { ...axios.defaults.headers.common, 'Content-Type': 'application/json' },
            body: JSON.stringify(searchObject)
        })
            .then(t => t.json())
            .then(json => {
                if (json.message || json.errorMessage) {
                    return alert(json.message || json.errorMessage)
                }

                this.setState({ data: json })
            })
    }

    hotspotterSearch = (searchString) => {
        document.getElementById('searchResults').scrollIntoView({ behavior: "smooth" })

        this.setState({ input: { packageId: null, textInput: searchString, daysback: 7 } }, () => this.search())
    }

    shouldShow = (inputName) => {
        switch (inputName) {
            case "textInput": {
                if (this.state.input.packageId && this.state.input.packageId.length) return false
                return true
            }
            case "packageId": {
                if (this.state.input.textInput && this.state.input.textInput.length) return false


                return true
            }
        }
    }


    renderIndicatorsComponent = (o) => {
        const document = o.original

        return (
            <div style={{ padding: 10 }}>
                <div className="flex" style={{ pointerEvents: 'none' }}>
                    <div>
                        <h4>Avsändardata</h4>
                        <ReactJson enableClipboard={false} displayDataTypes={false} name={false} displayObjectSize={false} src={JSON.parse(document.pickupIndicators)} />
                    </div>
                    <div>
                        <h4>Mottagardata</h4>
                        <ReactJson displayDataTypes={false} name={false} displayObjectSize={false} src={JSON.parse(document.queryIndicators)} />
                        <br />
                    </div>
                </div>

                <div className="flex" style={{ justifyContent: 'flex-end' }}>
                    <button className="smallQbutton" onClick={() => this.setState({ showReRunModal: true, reRunModalData: document })}>Kör leverans igen</button>
                </div>
            </div>
        )
    }

    componentDidMount = () => {
        this.props.fetchCollection('carriers')
        window.scrollTo(0, 0)
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.search()
        }
    }

    onFiltersChange = (column, value) => {
        console.log(column, value)
        this.setState((prevState) => ({
            filter: {
                ...prevState.filter,
                [column]: value,
            },
        }))
    }

    render() {
        const { filter, data } = this.state
        const { carriers } = this.props

        return (
            <Grid fluid>
                {this.state.reRunModalData !== null ? <ReRunDeliveryModal data={this.state.reRunModalData} modalIsOpen={this.state.showReRunModal} closeModal={() => this.setState({ showReRunModal: false, reRunModalData: null })} /> : null}


                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Well>
                            <Hotspotter hotspotterSearch={this.hotspotterSearch} />
                        </Well>
                    </Col>
                </Row>

                <Row>
                    <Col md={4}>&nbsp;</Col>
                    <Col sm={12} md={2} lg={2}>
                        {this.shouldShow("packageId") && <div
                            style={{ borderRadius: 10, height: 42, fontSize: 14, cursor: "default" }}
                            className="delivery-filter-container">
                            <input
                                type="text"
                                onChange={this.updateSearch}
                                name="packageId"
                                placeholder="Paket ID"
                                className="Sök"
                                onKeyDown={this.keyDown} />
                        </div>}
                    </Col>

                    <Col sm={12} md={2} lg={2}>
                        {this.shouldShow("textInput") && <div
                            style={{ borderRadius: 10, height: 42, fontSize: 14, cursor: "default" }}
                            className="delivery-filter-container">
                            <input
                                type="text"
                                onChange={this.updateSearch}
                                name="textInput"
                                placeholder="Fritext"
                                className="Sök"
                                onKeyDown={this.keyDown} />
                        </div>}
                    </Col>

                    <Col md={2}>&nbsp;</Col>

                    <Col sm={12} md={2} lg={2}>
                        <div className="smallQbutton" style={{ width: '100%' }} onClick={this.search}>
                            Sök
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={12} lg={12}>
                        Träffar: {data.length}
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} id={'searchResults'}>
                        <ReactTable
                            data={filter.carrierId ? data.filter((d) => d.carrierId === filter.carrierId) : data}
                            filterable
                            columns={[
                                {
                                    Header: "Datum:",
                                    id: 'date',
                                    accessor: d => dayjs(d.date).format('HH:mm - DD/MM/YY')
                                },
                                {
                                    Header: "Paketid:",
                                    id: 'packageId',
                                    Cell: props => {
                                        const packageId = props.original.packageId
                                        return (
                                            <div>
                                                {packageId}<br />
                                                <PackageIdCheck packageId={packageId} />
                                            </div>
                                        )
                                    }
                                },
                                {
                                    Header: "Lev. id:",
                                    id: 'deliveryId',
                                    accessor: d => d.deliveryId
                                },
                                {
                                    Header: "Mottagarnamn:",
                                    id: 'receiverName',
                                    accessor: d => d.receiverName
                                },
                                {
                                    Header: "Event:",
                                    id: 'event',
                                    accessor: d => d.event
                                },
                                {
                                    Header: 'Vikt/dimension:',
                                    id: 'WeightDimension',
                                    accessor: d => {
                                        var str = ''

                                        if (d.packageWeight && d.packageWeight !== "empty") str += `${d.packageWeight} kg | `
                                        if (d.packageDimensions && d.packageDimensions !== "empty") str += `${d.packageDimensions}`

                                        if (!str.length) return ''

                                        return str
                                    }
                                },
                                {
                                    Header: "Avsändare:",
                                    id: 'senderName',
                                    accessor: d => d.senderName
                                },
                                {
                                    Header: "Transportör:",
                                    id: 'carrierId',
                                    accessor: d => { const carrier = carriers.find((c) => c._id === d.carrierId); if (carrier) return carrier.organization },
                                    Filter: () => <TableFilterDropdown fieldName="_id" filter={filter.carrierId} data={carriers} displayField="organization" onChange={(e) => this.onFiltersChange('carrierId', e.target.value)} />,
                                },
                                {
                                    Header: "",
                                    columns: [
                                        {
                                            expander: true,
                                            Header: () => <p>&nbsp;</p>,
                                            width: 65,
                                            Expander: ({ isExpanded, ...rest }) =>
                                                <div>
                                                    {isExpanded
                                                        ? <span>&#x2299;</span>
                                                        : <span>&#x2295;</span>}
                                                </div>,
                                            style: {
                                                cursor: "pointer",
                                                fontSize: 25,
                                                padding: "0",
                                                textAlign: "center",
                                                userSelect: "none"
                                            },
                                            Footer: () => <span>&hearts;</span>
                                        }
                                    ]
                                }
                            ]}
                            NoDataComponent={props => (null)}
                            showPagination={true}
                            showPageSizeOptions={false}
                            loading={!data.length}
                            loadingText=""
                            pageSize={data.length}
                            className="-striped -highlight"
                            SubComponent={this.renderIndicatorsComponent}
                            defaultFilterMethod={(filter, row) => {
                                const id = filter.pivotId || filter.id
                                return row[id] !== undefined ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {/* <NewDelivery /> */}
                    </Col>
                </Row>
            </Grid>
        )
    }

}


const mapProps = state => {
    return {
        carriers: state.collectionData.carriers,
    }
}

const mapDispatch = dispatch => {
    return {
        fetchCollection: (col) => dispatch(fetchCollection(col))
    }
}

export default connect(mapProps, mapDispatch)(DeliverySearch)
